import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'components/Icon';
import { ButtonIcon } from 'components/Button';

import './style.scss';

const ActionButton = ({ text, icon, color, closeIcon, closeText, isOpen, children, size, onClick, onSubmit }) => {
  const handleOpen = () => {
    if (onClick && !isOpen) {
      onClick(true);
    }
  };

  const handleClose = () => {
    if (onClick && isOpen) {
      onClick(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(e);
    }
  };

  return (
    <>
      <ButtonIcon className={`btn-main ${color}`} onClick={handleOpen} icon={icon} text={text}>
        {isOpen && children && (
          <div className="button-modal" style={{ left: size, right: size }}>
            <div className={`abstract-button ${color}`} onClick={handleClose}>
              <Icon name={icon} />
              <span className="button-text">{text}</span>
            </div>
            {children}

            <div className="flex-center">
              <ButtonIcon className="btn-modal" onClick={handleSubmit} icon={closeIcon} text={closeText} />
            </div>
          </div>
        )}
      </ButtonIcon>

      {isOpen && <div className="background-black" onClick={handleClose}></div>}
    </>
  );
};

ActionButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  onSubmit: PropTypes.func,
  isOpen: PropTypes.bool,
  size: PropTypes.string,
  children: PropTypes.node,
  closeIcon: PropTypes.string,
  closeText: PropTypes.string,
};

ActionButton.defaultProps = {
  closeText: 'Закрыть',
  closeIcon: 'addcircle',
  text: 'Кнопка',
  size: '50px',
  icon: '',
  color: '',
  isOpen: false,
};

export { ActionButton };
